import React from 'react'
import PropTypes from 'prop-types'
import Card from '../../../../../molecules/Card'
import Loading from '../../../../../molecules/Loading'
import { useGetThingSchema, useLevelThings } from '../../../../../../api/things'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import ThingContentForm from '../../../AssetDetails/ContentTab/Things/ThingContentForm'
import ErrorBoundary from '../../../../../molecules/ErrorBoundary'

export const AccountContentManagementView = ({ accountId }) => {
  const { data, isLoading } = useGetThingSchema(1)
  const { data: things, isLoading: thingValuesLoading } = useLevelThings(1, accountId)
  const accountData = {
    assetId: accountId,
    levelTypeId: 1
  }
  if (isLoading || thingValuesLoading) {
    return (
      <FadeIn>
        <Card>
          <Loading />
        </Card>
      </FadeIn>
    )
  }
  return (
    <ErrorBoundary name='Account Content Tab'>
      <FadeIn>
        <Card>
          <ThingContentForm asset={accountData} schema={data?.schema} values={things} />
        </Card>
      </FadeIn>
    </ErrorBoundary>
  )
}

AccountContentManagementView.propTypes = {
  accountId: PropTypes.number
}
